import { render, staticRenderFns } from "./PartnerOrderRequestDetails.vue?vue&type=template&id=97284a60&scoped=true&"
import script from "./PartnerOrderRequestDetails.vue?vue&type=script&lang=js&"
export * from "./PartnerOrderRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./PartnerOrderRequestDetails.vue?vue&type=style&index=0&id=97284a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97284a60",
  null
  
)

export default component.exports